module.exports = __webpack_public_path__ + "img/box-green-opened.63180d75.png";